import { jsxs as D, jsx as r } from "react/jsx-runtime";
import { CloseIcon as I } from "../../icons/close-icon.mjs";
import { SearchIcon as j } from "../../icons/search-icon.mjs";
import { twMerge as i } from "tailwind-merge";
import { FieldErrorAndDescription as z } from "../form/field-error-and-description.mjs";
import { FieldLabel as E } from "../form/field-label.mjs";
import { useTranslation as F } from "../../i18n/hooks.mjs";
import { getDataTestAttributes as S } from "../../utils/get-data-test-attributes.mjs";
function B({
  inputRef: n,
  label: t,
  labelClassName: m,
  required: c,
  value: a,
  onChange: d,
  onFocus: u,
  maxLength: b,
  error: o,
  placeholder: x,
  onClear: f,
  description: y,
  testAttributePostfix: l,
  isPreFetching: s,
  searchIconClassName: g,
  closeIconClassName: h,
  errorAndDescriptionClassName: k,
  descriptionClassName: N,
  errorClassName: w,
  showSearchIcon: $,
  ...e
}) {
  const { t: C } = F();
  return /* @__PURE__ */ D("label", { className: `${e.className} relative flex flex-col gap-1 text-sm font-medium`, children: [
    /* @__PURE__ */ r(E, { label: t, labelClassName: m, required: c }),
    (a === "" || $) && /* @__PURE__ */ r(
      j,
      {
        className: i(
          "z-1 absolute right-4 h-[21px] w-[21px] translate-y-1/2 scale-75",
          t && "top-[24px]",
          g
        )
      }
    ),
    a !== "" && /* @__PURE__ */ r(
      I,
      {
        onClick: f,
        className: i(
          "z-1 fill-text-primary absolute right-2 h-[21px] w-[21px] translate-y-1/2 scale-75 cursor-pointer",
          t && "top-[24px]",
          h
        )
      }
    ),
    /* @__PURE__ */ r(
      "input",
      {
        ref: n,
        className: `text-text-primary main-transition-colors bg-background-secondary relative w-full rounded-lg border ${o ? "border-danger" : "border-text-secondary/30"} focus:border-brand-primary placeholder:text-text-tertiary/70 py-2.5 pl-4 pr-8 focus:outline-hidden ${s ? "bg-skeleton-primary/40 disabled:bg-skeleton-primary/40 animate-pulse text-transparent" : "disabled:bg-background-tertiary/40"} ${e.inputClassName || ""}`,
        onKeyDown: (p) => e.type === "number" && ["e", "E", "+", "-"].includes(p.key) && p.preventDefault(),
        type: e.type || "text",
        disabled: e.disabled || s,
        value: a,
        onChange: d,
        onFocus: u,
        maxLength: b,
        placeholder: x || C("public_pages_purchase.input.search"),
        spellCheck: !1,
        ...S(!!l, `${l}`)
      }
    ),
    /* @__PURE__ */ r(
      z,
      {
        description: y,
        error: o,
        className: k,
        descriptionClassName: N,
        errorClassName: w
      }
    )
  ] });
}
export {
  B as FormInputSearch
};
